import Cookies from 'universal-cookie';
import { HttpResponse, ServiceClient } from '@johnlewispartnership/wtr-website-api-client';
import config from 'config';
import { logApiError } from 'logger';
import { type Banner, type BannerRequest, type CategoryPath } from 'services/banners/types';
import getApiBaseUrl from 'utils/getApiBaseUrl';

const getCookies = () => new Cookies();

class BannerServiceClient extends ServiceClient {
  static apiPath = '/adtech/banners';

  async getBanners({
    categories,
    trolleyId,
    authToken,
  }: {
    categories: CategoryPath[];
    trolleyId: string;
    authToken: string;
  }): Promise<Banner[]> {
    const response = await this.httpClient
      .post<BannerRequest>(
        BannerServiceClient.apiPath,
        {
          type: 'MEGA_MENU',
          categories,
          trolleyId,
        },
        {
          headers: {
            'wtr-uuid': getCookies().get('wtr_uuid'),
            authorization: authToken,
          },
        },
      )
      .catch(e => ({ error: e }) as HttpResponse<Banner>);

    return response.data && !response.error
      ? response.data.bannerAds
      : (() => {
          logApiError({
            payload: {
              service: 'banners',
              url: `${getApiBaseUrl(config.services.banners.path)}${BannerServiceClient.apiPath}`,
              message: `Error getting banners: ${response.error?.message || 'No message'}`,
              duration: response.duration,
              httpStatus: `${response.status}`,
              httpStatusCode: response.status,
            },
          });
          return [];
        })();
  }
}

export default new BannerServiceClient(getApiBaseUrl(config.services.banners.path));
